import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { DARK_CHART_COLORS, LIGHT_CHART_COLORS, THEME } from '../constants';

const useChartColors = () => {
  const theme = useSelector((state) => state.global.theme);

  return useMemo(() => (theme === THEME.DARK ? DARK_CHART_COLORS : LIGHT_CHART_COLORS), [theme]);
};

export default useChartColors;
